<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-block">
      <div class="left-img" style="background-image: url(assets/images/pages/404.webp);">
      </div>
    </div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <div>
            <span class="error-header p-b-45">
             404
            </span>
            <span class="error-subheader p-b-5">
              Похоже, ты заблудился
            </span>
            <span class="error-subheader2 p-b-5">
              Страница, которую вы ищете, недоступна!
            </span>
            <div class="container-auth-form-btn mt-5">
              <a href="/" mat-flat-button color="primary" class="auth-form-btn" >
                Вернуться на домашнюю страницу
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
